import { CONFIG } from '../utils/config';
import { apiSlice } from './apiSlice';

// Employee wellness CMS content API
// URL base varies per environment: see REACT_APP_CMS_API_URL in each .env file.
// Backend returns { success, data: { heroBanner, tabs, platforms, panes } }
export const employeeWellnessPageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEmployeeWellnessContent: builder.query({
      query: () => ({
        url: `${CONFIG.CMS_API_URL}/employee-wellness`,
        method: 'GET',
        headers: { source: 'adp.com' },
      }),
      providesTags: ['EmployeeWellnessContent'],
      transformResponse: (response) => response?.data ?? null,
      transformErrorResponse: (response) => {
        console.error('Failed to fetch employee wellness content:', response?.data || 'API Error');
        return null;
      },
    }),
  }),
});

export const { useGetEmployeeWellnessContentQuery } = employeeWellnessPageApi;
